/** @deprecated */
export function useColorScheme() {
  // TODO: Support color schemes on web.
  return 'light'
}
